<template>
  <div class="consultation">
    <el-dialog :title="title" :close-on-click-modal="false" :visible.sync="showDialog" width="70%" top="8vh"
      @close="setDialogClosed" append-to-body>
      <el-container class="container" direction="vertical">
        <template>
          <el-descriptions :column="6" border>
            <el-descriptions-item label="患者姓名" span="2">{{ lastPageForm.patientName || '-' }}</el-descriptions-item>
            <el-descriptions-item label="登记号" span="2">{{ lastPageForm.recordNo || '-' }}</el-descriptions-item>
            <el-descriptions-item label="联系方式" span="2">{{ lastPageForm.phone || '-' }}</el-descriptions-item>
            <el-descriptions-item label="报告编号" span="3">{{ lastPageForm?.examReportInfo?.reportCode || '-'
            }}</el-descriptions-item>
            <el-descriptions-item label="检测时间" span="2">{{ getStandardDate(lastPageForm?.examReportInfo?.reportTime) ||
              '-'
            }}</el-descriptions-item>
          </el-descriptions>
        </template>

        <template>
          <el-table :data="lastPageForm?.examReportInfo?.examItems" border
            style="width: 100%;margin: 10px 0px;height: 200px;">
            <el-table-column prop="itemName" label="项目" width="240" align="center">
            </el-table-column>
            <el-table-column prop="examObserved" label="描述" align="center">
            </el-table-column>
            <el-table-column prop="examResult" label="结论" align="center">
            </el-table-column>
          </el-table>
        </template>

        <template>
          <el-descriptions :column="4" border>
            <el-descriptions-item label="管理标签*" span="4">
              <el-select v-if="!isAdd" v-model="form.diseaseGroup" placeholder="请选择" :disabled="isRead">
                <el-option v-for="(x, index) in manageTagsList" :key="index" :label="x.label" :value="x.value" />
              </el-select>
              <el-input v-if="isAdd" placeholder="请输入内容" v-model="subForm.diseaseGroup"
                style="width: 220px;"></el-input>
              <el-button v-if="!isRead" type="primary" style="margin-left: 10px;" @click="handleAddManageTag">{{ isAdd ?
                '新增' : '选择'
              }}</el-button>
            </el-descriptions-item>
            <el-descriptions-item label="生活方式指导" span="4">
              <div style="padding: 10px;">
                <div style="display: flex;align-items: center;gap: 18px;margin-bottom: 10px;">
                  <div style="width: 160px;">
                    <el-checkbox v-model="form.checked1" label="戒烟" border :disabled="isRead"></el-checkbox>
                  </div>
                  <div style="width: 480px;">
                    吸烟是肺癌的主要危险因素，戒烟是降低肺癌风险最直接有效的方法。无论吸烟时间长短，
                    戒烟后肺部修复功能会逐渐恢复，肺癌风险也会逐步下降。
                    避免二手烟和三手烟：长期暴露在二手烟环境中同样会增加患肺癌的风险，应尽量避免接
                    触二手烟。同时，注意避免“三手烟”，即烟草燃烧后残留在衣物、家具、墙壁等表面的有
                    害物质
                  </div>
                </div>
                <div style="display: flex;align-items: center;gap: 18px;margin-bottom: 10px;">
                  <div style="width: 160px;">
                    <el-checkbox v-model="form.checked2" label="限酒" border :disabled="isRead"></el-checkbox>
                  </div>
                  <div style="width: 480px;">
                    过量饮酒可能影响身体免疫功能，增加患癌风险，建议适量饮酒或避免饮酒。
                  </div>
                </div>
                <div style="display: flex;align-items: center;gap: 18px;margin-bottom: 10px;">
                  <div style="width: 160px;">
                    <el-checkbox v-model="form.checked3" label="室内通风" border :disabled="isRead"></el-checkbox>
                  </div>
                  <div style="width: 480px;">
                    保持室内空气流通，定期开窗通风，减少室内污染物积聚。
                  </div>
                </div>
                <div style="display: flex;align-items: center;gap: 18px;margin-bottom: 10px;">
                  <div style="width: 160px;">
                    <el-checkbox v-model="form.checked4" label="减少油烟暴露" border :disabled="isRead"></el-checkbox>
                  </div>
                  <div style="width: 480px;">
                    烹饪时打开抽油烟机，避免高温油炸、煎炒，减少厨房油烟产生。
                  </div>
                </div>
                <div style="display: flex;align-items: center;gap: 18px;margin-bottom: 10px;">
                  <div style="width: 160px;">
                    <el-checkbox v-model="form.checked5" label="增加蔬果摄入" border :disabled="isRead"></el-checkbox>
                  </div>
                  <div style="width: 480px;">
                    多吃新鲜蔬菜和水果，如苹果、西红柿、胡萝卜、西兰花等，它们富含维生素、矿物质和
                    抗氧化剂，有助于降低肺癌风险
                  </div>
                </div>
              </div>
            </el-descriptions-item>
            <el-descriptions-item label="随诊建议*" span="4">
              <el-select v-model="form.followup" placeholder="请选择" style="min-width: 70%;" :disabled="isRead">
                <el-option v-for="(x, index) in followupSuggestionsList" :key="index" :label="x.label"
                  :value="x.value + '_' + x.label" />
              </el-select>
            </el-descriptions-item>
            <el-descriptions-item label="其它" span="4" v-if="form.followup === '10_其他'">
              <el-input type="textarea" placeholder="请输入内容" v-model="form.lungcancerGuideOther" :rows="2"
                :disabled="isRead"></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="复查到期时间*" span="4">
              <el-checkbox v-model="form.noReview" :disabled="isRead" style="margin-right: 12px;">不复查</el-checkbox>
              <el-date-picker type="date" placeholder="选择复查到期时间" v-model="form.reviewTime"
                :disabled="isRead || form.noReview"></el-date-picker>
            </el-descriptions-item>
          </el-descriptions>
        </template>

      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button style="margin-right: 12px;" type="primary" @click="setDialogClosed">关闭</el-button>

        <el-popconfirm title="是否确认提交？" @confirm="handleSubmit" v-if="!isRead">
          <el-button slot="reference" type="primary">一键协诊</el-button>
        </el-popconfirm>
        <!-- <el-button type="primary" v-if="!isRead" @click="handleSubmit">一键协诊</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { getCoDiagDirect, getUserInfos, getSysDicList, getlistClinicItem, getMedicineList } from "@/api/health/Patients";
import { postAddPatientFollowupGroup, postCoDiagnosisNotification, postPatientFollowupGroupsByGroupName } from "@/api/health/Lung";
import moment from "moment";
import { getFormatDate } from '../../utils/tools'

export default {
  data() {
    return {
      loading1: false,
      loading2: false,
      isRead: false,
      title: "一键协诊",
      showDialog: false,
      isAdd: false,
      form: {
        diseaseGroup: null,
        reviewTime: null,
        noReview: false,
        followup: null,
        lungcancerGuideOther: null,
        checked1: false,
        checked2: false,
        checked3: false,
        checked4: false,
        checked5: false,
      },
      subForm: {
        diseaseGroup: null,
      },
      lastPageForm: {},
      tableData: [{
        name: '胸部高分辨CT平扫',
        des: '双肺可见少许条索状、斑片状高密度灶，边界清晰。段及段以上支气管通畅。纵隔内未见明显肿大淋巴结。肝密度减低，见多发类圆形、不规则高密度灶。左侧肾上腺见结节灶，约16mm。',
        result: '1.符合双肺少许慢性炎性病变CT平扫表现；2.符合脂肪肝CT平扫表现，肝多发高密度灶，请结合临床，建议进一步检查；3.左侧肾上腺结节，建议CT增强检查。'
      }],
      // 管理标签
      manageTagsList: [],
      followupSuggestionsList: [
        { label: "每餐主食≤2两", value: "每餐主食≤2两" },
        { label: "少油低盐", value: "少油低盐" },
        { label: "避免煎、炸、红烧等烹饪方式", value: "避免煎、炸、红烧等烹饪方式" },
        { label: "适度饮水", value: "适度饮水" }
      ],
    }
  },
  created() {
    this.getSystemDictList('肺结节协诊')
  },
  watch: {
    'form.followup'(val) {
      if (!val) return;
      const label = val.includes('_') ? val.split('_')[1] : val;
      const today = new Date();
      let targetDate;
      if (label.includes('一年')) {
        targetDate = new Date(today.getFullYear() + 1, today.getMonth(), today.getDate());
      } else if (label.includes('半年') || label.includes('六月')) {
        targetDate = new Date(today.getFullYear(), today.getMonth() + 6, today.getDate());
      } else if (label.includes('三个月') || label.includes('三月')) {
        targetDate = new Date(today.getFullYear(), today.getMonth() + 3, today.getDate());
      } else if (label.includes('一个月') || label.includes('一月')) {
        targetDate = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate());
      } else {
        targetDate = new Date(today);
      }
      this.form.reviewTime = targetDate;
    },
    'form.noReview'(val) {
      if (val) {
        this.form.reviewTime = null;
      }
    }
  },
  methods: {
    async init(value) {
      // console.warn("一键协诊弹窗数据：", value);
      this.lastPageForm = { ...value };
      this.isRead = value.isRead;
      if (this.isRead) {
        this.title = "协诊详情";
        this.form.diseaseGroup = value.record?.diseaseGroup;
        this.form.checked1 = value.record?.lifestyleGuide?.includes('戒烟') || false;
        this.form.checked2 = value.record?.lifestyleGuide?.includes('限酒') || false;
        this.form.checked3 = value.record?.lifestyleGuide?.includes('室内通风') || false;
        this.form.checked4 = value.record?.lifestyleGuide?.includes('减少油烟暴露')
          || false;
        this.form.checked5 = value.record?.lifestyleGuide?.includes('增加蔬果摄入') || false;
        this.form.followup = value.record?.lungcanerGuideId && value.record?.lungcanerGuide ? value.record?.lungcanerGuideId + '_' + value.record?.lungcanerGuide : undefined;
        this.form.reviewTime = value.record?.reviewTime;
        this.form.noReview = value.record?.reviewFlag === 0;
        this.form.lungcancerGuideOther = value.record?.lungcancerGuideOther;
      }
      this.getSystemTime();
      this.getManageTagsList();
      getUserInfos({}).then((res) => {
        if (res.msg == "success") {
          console.warn(res, "获取协诊机构电话")

          this.showDialog = true;
        }
      }).catch((error) => {
        console.log(error);
      })
    },
    setDialogClosed() {
      this.showDialog = false;
    },
    async handleSubmit() {
      // console.warn("一键协诊提交：", this.form);
      if (!this.form.diseaseGroup && (!this.subForm.diseaseGroup && this.isAdd)) {
        this.$message({
          message: "请选择或添加管理标签！",
          type: "error"
        })
        return;
      }
      if (!this.form.followup) {
        this.$message({
          message: "请选择随诊建议！",
          type: "error"
        })
        return;
      }
      if (!this.form.reviewTime && !this.form.noReview) {
        this.$message({
          message: "请选择复查到期时间！",
          type: "error"
        })
        return;
      }
      if (this.isAdd) {
        this.form.diseaseGroup = null;
        try {
          const addRes = await postAddPatientFollowupGroup({ groupName: this.subForm.diseaseGroup || '' });
          if (!addRes || addRes.msg !== 'success' || addRes.code === 500) {
            this.$message({
              message: (addRes && addRes.msg) || '新增管理标签失败！',
              type: 'error'
            });
            return; // 中断后续提交，避免继续走下去
          }
        } catch (err) {
          console.log(err);
          this.$message({
            message: err.msg || '新增管理标签失败！',
            type: 'error'
          });
          return; // 出现异常也中断后续提交
        }
      } else {
        this.subForm.diseaseGroup = null;
      }
      let arr = [{ label: "戒烟", value: this.form.checked1 }, { label: "限酒", value: this.form.checked2 }, { label: "室内通风", value: this.form.checked3 },
      { label: "减少油烟暴露", value: this.form.checked4 }, { label: "增加蔬果摄入", value: this.form.checked5 }];
      let str = arr.filter(x => x.value).map(x => x.label).join(',');
      await postCoDiagnosisNotification({
        id: this.lastPageForm.id,
        record: {
          diseaseGroup: !this.isAdd ? this.form.diseaseGroup : this.subForm.diseaseGroup,
          lungcanerGuideId: this.form.followup?.split('_')[0],
          lungcanerGuide: this.form.followup?.split('_')[1],
          reviewTime: this.form.reviewTime ? getFormatDate(this.form.reviewTime) : null,
          reviewFlag: this.form.noReview ? 0 : 1,
          lifestyleGuide: str ? str : null,
          lungcancerGuideOther: this.form.followup === '10_其他' ? this.form.lungcancerGuideOther : null,
        }
      }).then(res => {
        if (res.msg === 'success') {
          this.$message({
            message: "一键协诊提交成功！",
            type: "success"
          })
          this.$emit("upDataList");
          this.setDialogClosed();
        } else {
          this.$message({
            message: res.msg || "一键协诊提交失败！",
            type: "error"
          })
        }
      }).catch(err => {
        console.log(err);
        this.$message({
          message: err.message || "一键协诊提交失败！",
          type: "error"
        })
      })
    },
    handleAddManageTag() {
      this.isAdd = !this.isAdd;
      return
    },
    async getManageTagsList() {
      postPatientFollowupGroupsByGroupName({}).then(res => {
        if (res.msg === 'success') {
          this.manageTagsList = (res.data?.records || []).map(x => ({
            label: x.groupName,
            value: x.groupName
          }));
        }
      }).catch(err => console.log(err));
    },
    getSystemDictList(typeName) {
      var typeData = {
        "typeName": typeName
      };
      getSysDicList(typeData).then(res => {
        var records = [];
        if (res.msg == "success") {
          var data = res.data;
          records = data.records;
        }
        this.followupSuggestionsList = [...records.map(x => ({ label: x.name, value: x.value })) || []];
        // this.sexOptions = records;
      }).catch(err => {
        console.log(err);
      })
    },
    // getFormatDate(dateString) {
    //   const formattedDate = moment(dateString).format('YYYY-MM-DD');
    //   return formattedDate;
    // },
    getStandardDate(dateString) {
      const formattedDate = moment(dateString).format('YYYY-MM-DD HH:mm');
      return formattedDate;
    },
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date((new Date(time) / 1000 + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return (
        year +
        "-" +
        (month < 10 ? "0" + month : month) +
        "-" +
        (date < 10 ? "0" + date : date)
      );
    },
    // 获取系统时间
    getSystemTime() {
      // 实例化日期类
      var time = new Date();
      // 获取完整的年份(4位)
      var year = time.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = time.getMonth();
      // 获取日期(1-31)
      var date = time.getDate();
      var hour = time.getHours();
      var minute = time.getMinutes();
      var second = time.getSeconds();
      //测试打印
      console.log(year + "年" + month + "月" + date + "日 ");
      time.setFullYear(year, month, date);
      time.setHours(hour, minute, second);

      // this.listQueryData.codiagTime = time.Format("yyyy-MM-dd hh:mm:ss"); //yyyy-MM-dd'T'HH:mm:ss.SSSZ
    },
  }

}
</script>
<style lang="scss" scoped>
.container {
  // height: 480px !important;
  overflow: auto !important;
}
</style>